import { render } from "./TransferAgentView.vue?vue&type=template&id=98215e78&scoped=true"
import script from "./TransferAgentView.vue?vue&type=script&lang=js"
export * from "./TransferAgentView.vue?vue&type=script&lang=js"

import "./TransferAgentView.vue?vue&type=style&index=0&id=98215e78&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-98215e78"]])

export default __exports__